// extracted by mini-css-extract-plugin
export default {"riskFactorEditList":"RiskFactorEditList_riskFactorEditList__G758J"};